import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import {
  CHUNK_LOAD_RECOVERY,
  ChunkLoadRecovery,
} from './chunk-load-recovery.token';
import { createBrowserChunkLoadRecovery } from './chunk-load-recovery';
import { LazyTranslateLoader } from './lazy-translate.loader';

const noopChunkLoadRecovery: ChunkLoadRecovery = {
  clearReloadMarker(): void {},
  handleChunkLoadFailure(): void {},
};

export function provideLazyTranslateLoader(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: CHUNK_LOAD_RECOVERY,
      useFactory: (): ChunkLoadRecovery => {
        if (typeof window === 'undefined') {
          return noopChunkLoadRecovery;
        }

        return createBrowserChunkLoadRecovery();
      },
    },
    {
      provide: TranslateLoader,
      useClass: LazyTranslateLoader,
    },
  ]);
}
